export function Logo({ className = "h-10", testId, light = false }) {
  return (
    <img
      src="/brand/neurialabs-transparent.png"
      alt="NeuriaLabs"
      width={738}
      height={186}
      data-testid={testId}
      className={`block w-auto max-w-full object-contain ${light ? "brightness-0 invert" : ""} ${className}`}
      decoding="async"
    />
  );
}
